import { type GetQrCodePayloadDataType } from '@models/requests/payloads'

export const prepareQrCodeParams = (payloadData: GetQrCodePayloadDataType): string => {
  return (Object.keys(payloadData) as (keyof GetQrCodePayloadDataType)[]).reduce((acc, cur) => {
    if (cur !== 'data') {
      acc += `&${cur}=${payloadData[cur]}`
    }

    return acc
  }, `?data=${encodeURIComponent(payloadData.data)}`)
}
